import React, { Component } from 'react';
import classNames from 'classnames';
import Cleave from 'cleave.js/dist/cleave-react';
import _ from 'lodash';

class PriceInputContainer extends Component {
    constructor(props) {
        super(props);
        this.onBlur = this.onBlur.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.state = {
            value: '',
            modifiedCreditDebit: [],
        };
    }

    handleKeyDown() {
        if (this.state.value === 0)  {
            this.setState({
                value: ''
            })
        }
    }

    onBlur(event) {
        let value = Number(event.target.value);
            value = _.isNaN(value) ? 0 : value;
            let prem = this.props.ratedPremium*value
                prem = prem.toString().indexOf('.') != -1 ? Number(prem.toFixed(2)) : prem;
            this.props.onBlurTextboxHandler({[event.target.id] : prem}, this.state.modifiedCreditDebit, event.target.value)
            this.setState({ value: event.target.value});
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.scheduleFactor !== 0 && nextProps.scheduleFactor !== this.state.value) {
            this.setState({
                modifiedCreditDebit: [nextProps.scheduleFactor],
            })
        }
    }

    render() {
        const _value = this.props.scheduleFactor && this.props.scheduleFactor != this.state.value ? this.props.scheduleFactor : this.state.value;
        
            return (<div style={{height:'34px'}}><div className='row' style={{height:'34px'}}>
            <Cleave
            id={this.props.options.value}
            className={classNames(
                'form-control',
                'number-control',
                'input-numeral',
                'credit-debit',
                'price-input-container',
                'col-xs-10'
            )}
            disabled={this.props.disable}
            autoComplete={false}
            value={_value && (String(_value).endsWith('.') || _value % 1 != 0) ? _value : (_value && typeof _value == 'number'? _value.toFixed(1) : _value)}
            options={{
                numeral: true,
                numeralPositveOnly:true,
                numeralThousandsGroupStyle: 'none',
                numeralDecimalScale: 4,
                numeralDecimalMark: '.',
            }}
            onBlur={this.onBlur}
            onKeyDown={this.handleKeyDown}                
        />
        </div>
        {_value<0.5 && _value != 0 && !this.props.disable ? <p className='Maxlimit'>{`Minimum allowed credit is 0.5`} </p> : '' }</div>
        );
    }
}

export default PriceInputContainer;